import { format } from "date-fns";
import TrackIcon from "@/assets/icons/track-outline.svg?react";
import { TrackingListElem } from "./trackingListElem";
import { enGB, fr } from "date-fns/locale";
import { DatesAndTimes, StandardTransitTimeWindow } from "@/types/fedex.type";

type TrackingShippingOverviewProps = {
  dateAndTimes: DatesAndTimes[];
  trackingNumber: string;
  standardTransitTimeWindow: StandardTransitTimeWindow;
  locale: string;
};

export const TrackingShippingOverview = ({
  dateAndTimes,
  trackingNumber,
  standardTransitTimeWindow,
  locale,
}: TrackingShippingOverviewProps) => {
  const formatDate = (date?: string) => {
    if (!date) return locale === "fr" ? "Sera bientôt disponible" : "Available soon";
    return format(new Date(date), "dd MMM yyyy", {
      locale: locale === "fr" ? fr : enGB,
    });
  };

  return (
    <div className="flex w-full flex-col gap-5 rounded-xl border border-gray-200 bg-white p-6 shadow-xs">
      <div className="flex w-full flex-row items-center gap-4">
        <TrackIcon width={24} height={24} />
        <span className="text-sm font-semibold text-black">
          {locale === "fr" ? "Aperçu de l'expédition" : "Tracking overview"}
        </span>
      </div>
      <div className="flex w-full flex-col gap-0">
        <div className={`flex w-full flex-row border-b border-gray-200 py-4`}>
          <span className="flex-1 text-xs font-medium text-gray-600">
            {locale === "fr" ? "Numéro de suivi" : "Tracking number"}
          </span>
          <a
            className="flex-1 text-sm font-medium"
            href={`https://www.fedex.com/fedextrack/?trknbr=${trackingNumber}`}
          >
            {trackingNumber}
          </a>
        </div>
        <TrackingListElem
          name={locale === "fr" ? "Date d’expédition" : "Delivery date"}
          value={formatDate(
            dateAndTimes.find((el) => el.type === "ACTUAL_PICKUP")?.dateTime || undefined,
          )}
        />
        <TrackingListElem
          name={locale === "fr" ? "Transit standard" : "Standard transit time"}
          value={
            (standardTransitTimeWindow &&
              standardTransitTimeWindow?.window.ends &&
              formatDate(standardTransitTimeWindow.window.ends)) ||
            "N/A"
          }
        />
        <TrackingListElem
          name={locale === "fr" ? "Livré" : "Delivered"}
          value={formatDate(
            dateAndTimes.find((el) => el.type === "ACTUAL_DELIVERY")?.dateTime || undefined,
          )}
          last
        />
      </div>
    </div>
  );
};
